export enum OtherDiagramObject {
  DIAGRAM_COMMENT = 'diagram-comment',
}
